import * as Sentry from '@sentry/browser'

export const logError = error => {
  if (process.env.NODE_ENV === 'production') {
    Sentry.captureException(error)
  } else {
    console.error(error.message, error)
  }
}
